import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function VolumeOn({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M13.3334 4C13.3334 3.73036 13.171 3.48727 12.9219 3.38408C12.6728 3.28089 12.386 3.33793 12.1953 3.52859L7.72394 8H3.33341C2.96522 8 2.66675 8.29848 2.66675 8.66667V15.3333C2.66675 15.7015 2.96522 16 3.33341 16H7.72394L12.1953 20.4714C12.386 20.6621 12.6728 20.7191 12.9219 20.6159C13.171 20.5127 13.3334 20.2696 13.3334 20V4ZM8.47149 9.13807L12.0001 5.60947V18.3905L8.47149 14.8619C8.34646 14.7369 8.17689 14.6667 8.00008 14.6667H4.00008V9.33333H8.00008C8.17689 9.33333 8.34646 9.26309 8.47149 9.13807ZM21.3334 12C21.3334 14.5773 20.2887 16.9107 18.5997 18.5997L17.6569 17.6569C19.1046 16.2092 20.0001 14.2091 20.0001 12C20.0001 9.79085 19.1046 7.79085 17.6569 6.34314L18.5997 5.40033C20.2887 7.08933 21.3334 9.42266 21.3334 12ZM18 12C18 13.6569 17.3285 15.1569 16.2427 16.2427L15.2999 15.2999C16.1444 14.4554 16.6667 13.2887 16.6667 12C16.6667 10.7114 16.1444 9.54469 15.2999 8.70019L16.2427 7.75738C17.3285 8.84317 18 10.3432 18 12Z"
        fill={iconColor}
      />
    </Svg>
  );
}
